import React from 'react';
import { BadgePercent, Clock } from 'lucide-react';
import { promotionEndsText, storeToday } from '../../utils/promotions';

const THEMES = {
  default: { bg: 'bg-gradient-to-br from-rose-50 to-orange-50', border: 'border-rose-200', badge: 'bg-rose-600' },
  instamart: { bg: 'bg-gradient-to-br from-green-50 to-emerald-50', border: 'border-green-200', badge: 'bg-[#0C831F]' },
  zepto: { bg: 'bg-gradient-to-br from-purple-50 to-violet-50', border: 'border-purple-200', badge: 'bg-[#5B2EBF]' },
  blinkit: { bg: 'bg-gradient-to-br from-yellow-50 to-amber-50', border: 'border-yellow-300', badge: 'bg-[#E8A318]' },
  country: { bg: 'bg-gradient-to-br from-green-50 to-teal-50', border: 'border-green-200', badge: 'bg-[#00B37A]' },
};

/**
 * The store's live promotions on the home page. They apply by themselves —
 * the prices on the product cards and in the cart already include them — so,
 * unlike coupons, there is nothing to copy or apply.
 */
export const PromotionStrip = ({ promotions, variant = 'default' }) => {
  if (!promotions || promotions.length === 0) return null;
  const t = THEMES[variant] || THEMES.default;
  const today = storeToday();

  return (
    <section className="mb-4" data-testid="promotion-strip" aria-label="Promotions">
      <div className="flex items-center justify-between px-4 mb-2">
        <h3 className="font-bold text-sm text-[var(--theme-text-main)] flex items-center gap-1.5">
          <BadgePercent className="w-4 h-4" aria-hidden="true" /> Promotions
        </h3>
        <span className="text-xs text-[var(--theme-text-muted)]">Applied automatically</span>
      </div>
      <div className="flex gap-3 overflow-x-auto px-4 pb-2 snap-x" style={{ scrollbarWidth: 'none' }}>
        {promotions.slice(0, 10).map((promo) => (
          <article
            key={promo.id}
            className={`snap-start shrink-0 w-60 max-w-[80vw] ${t.bg} border ${t.border} rounded-xl p-3`}
            data-testid={`promotion-${promo.id}`}
          >
            <span className={`inline-block ${t.badge} text-white text-[11px] font-bold px-2 py-0.5 rounded-md`}>{promo.label}</span>
            <p className="mt-1.5 text-sm font-semibold text-[var(--theme-text-main)] line-clamp-1">{promo.name}</p>
            {promo.description && (
              <p className="text-xs text-[var(--theme-text-muted)] line-clamp-2 mt-0.5">{promo.description}</p>
            )}
            <div className="flex items-center justify-between gap-2 mt-2 text-[11px] text-[var(--theme-text-muted)]">
              <span className="truncate">{promo.scope}</span>
              <span className="shrink-0 flex items-center gap-1">
                <Clock className="w-3 h-3" aria-hidden="true" /> {promotionEndsText(promo.end_date, today)}
              </span>
            </div>
          </article>
        ))}
      </div>
    </section>
  );
};
